<section class="pos-uploads">
    <div class="row">
        <div class="col-md-7">
            <h4 class="text-white"><b>POS Uploads<small>({{ posuploaddata.length }})</small></b></h4>
        </div>
        <div class="col-md-5 text-right">
            <div id="dwtcontrolContainer" class="d-none"></div>
            <button class="btn btn-sm btn-primary mr-2" type="button" (click)="getPOSChecksData()">Refresh</button>
            <button class="btn btn-sm btn-primary mr-2"
                type="button" (click)="scanPosChecks(selectDateToScan,'upload')">Upload</button>
            <button class="btn btn-sm btn-primary mr-2"
                type="button" (click)="scanPosChecks(selectDateToScan,'scan')">Scan</button>

            <button type="button" class="btn btn-sm btn-primary mr-2" (click)="reprocessCheck()"><i
                    class="ri-loop-left-fill mr-1"></i>Re-process</button>
            <button type="button" class="btn btn-sm btn-primary" [routerLink]="['/home/pos-bills']">POS Checks</button>
        </div>
    </div>
    <div class="card ">
        <div class="card-body p-0">
            <div class="table-responsive">
                <table class="table-bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Status</th>
                              <th>Error Response</th>
                              <th>Uploaded Date</th>
                            <th>Creation Date</th>
                          
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>
                                <div class="form-group  pl-2 mb-0">
                                    <div class="review-pending-check">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input"
                                                id="customizedCheckAll" name="itemAll" [(ngModel)]="underprocessing"
                                                (ngModelChange)="checked_pending()">
                                            <label class="custom-control-label " for="customizedCheckAll" ngbTooltip="Select Pending">
                                                Pending
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                                <div class="form-group mb-0">
                                    <div class="d-flex check-date">
                                        <input class="form-control h-auto" [(ngModel)]="this.filters.selectCreationDate"
                                            style="border: none;"
                                            [max]="today" [min]="calculateMinDate()"
                                            (dateTimeChange)="selectCheckDate_new($event)" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1"
                                            name="selectCreationDate"
                                            placeholder="Date">
                                        <span *ngIf="!creation" class="example-trigger" [owlDateTimeTrigger]="dt1">
                                            <i class="ri-calendar-2-line ml-1"></i>
                                        </span>
                                        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                                        <i class="ri-close-fill close-icon " (click)="clearDate()" *ngIf="creation"></i>
                                    </div>
                                </div>
                            </td>
                            
                            <td></td>
                        </tr>
                        <tr *ngFor="let item of posuploaddata; let i = index">

                            <td>
                                {{ i+1 }}
                            </td>
                            <td>
                                {{ item?.name }}
                            </td>
                            <td>
                                {{ item?.status }}
                            </td>
                            <td>
                                {{item?.error_response}}
                            </td>
                            <td>
                                {{ item?.upload_date|date:'dd/MM/yyyy' }}
                            </td>
                            <td>
                                {{ item?.creation|date:'dd/MM/yyyy' }}
                            </td>
                            <td>
                                <a (click)="previewcheck(viewcheck,item)">
                                    <i class="ri-eye-fill"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="text-center py-3 bg-white" *ngIf="!posuploaddata.length">
                    <h5>No Data Found</h5>
                </div>
                <!-- <div class="d-flex pb-2 pt-2 justify-content-between" *ngIf="posuploaddata.length">
                    <div class="px-3">
                        <select class="custom-select border-none" name="itemsPerPage" [(ngModel)]="filters.itemsPerPage"
                            (change)="checkPagination()" id="itemsPerPage">
                            <option [value]="20">20</option>
                            <option [value]="50">50</option>
                            <option [value]="100">100</option>
                            <option [value]="150">150</option>
                            <option [value]="500">500</option>
                        </select>
                    </div>
                    <div *ngIf="posuploaddata.length  < this.filters.totalCount">
                        <p class="text-right pr-5 more text-primary"
                            (click)="this.filters.start = posuploaddata.length;this.filters.currentPage = this.filters.currentPage+1;  updateRouterParams()">
                            more
                        </p>
                    </div>
                </div> -->
            </div>
        </div>
    </div>

    <div class="card " style="display: none;">
        <div class="card-body p-1">
            <form #pos="ngForm">
                <div class=" border-btm">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="form-group  pl-2 mb-0">
                                <div class="review-pending-check">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input"
                                            id="customizedCheckAll" name="itemAll" [(ngModel)]="underprocessing"
                                            (ngModelChange)="checked_pending()">
                                        <label class="custom-control-label " for="customizedCheckAll" ngbTooltip="Select Pending">
                                            Pending
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 px-0">
                            <div class="form-group mb-0">
                                <div class="d-flex check-date">
                                    <label for="" class="mb-0">Uploaded Date</label>|
                                    <input class="form-control h-auto" [(ngModel)]="this.filters.selectCreationDate" style="border: none;"
                                        [max]="today" [min]="calculateMinDate()"
                                        (dateTimeChange)="selectCheckDate_new($event)" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1"
                                        name="selectCreationDate"
                                        placeholder="Date">
                                    <span *ngIf="!creation" class="example-trigger" [owlDateTimeTrigger]="dt1">
                                        <i class="ri-calendar-2-line"></i>
                                    </span>
                                    <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                                    <i class="ri-close-fill close-icon " (click)="clearDate()" *ngIf="creation"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row " *ngIf="posuploaddata.length">
                <div class="col-md-2 border-ryt scroll-bar pr-0">
                    <ul class="mt-2 invoice-status">
                        <ng-container *ngFor="let item of posuploaddata; let i = index">
                            <li class="invoice-review px-4 " (click)="getdatauploads(item)" [ngClass]="{'active': activeTab == item?.name}">
                                <p class="invoice-number m-0">{{ item?.name }}</p>
                                <small [ngClass]="{
                                'review-error': item?.status === 'Error',
                                'review-pending': item?.status === 'Pending',
                                'review-process': item?.status === 'Processing',
                                'review-success': item?.status === 'Completed'
                            }">
                                    {{ item?.status }}
                                </small>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                <div class="col-md-10 pl-0">
                    <div>
                        <div class="row">
                            <div class="col-md-8">
                                <!-- <div class="image-section mx-3">
                                <div class="bg-white img-label">
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <img src="../../../assets/images/fa_file-pdf-o.png" alt="">
                                            <small class="mx-2">
                                                <strong> firstcheck.pdf</strong>
                                            </small>
                                        </div>
                                        <div class="d-flex align-items-center">
                                            <span class="image-section-icons"><i class="ri-arrow-left-s-line"></i></span>
                                            <small>1 of 3</small>
                                            <span class="image-section-icons"><i class="ri-arrow-right-s-line"></i></span>
                                        </div>
                                        <div>
                                            <span class="image-section-icons mx-2"><i class="ri-anticlockwise-line"></i></span>
                                            <span class="image-section-icons mx-2"><i class="ri-printer-line"></i></span>
                                            <span class="image-section-icons mx-2"><i class="ri-download-line"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center py-2">
                                   
                                    <img src="../../../assets/images/checks_feb_page5838_page-0001 2.png" alt="">
                                   <span></span>
                                   
                                    <div class="zooming-image">
                                         <p class="mb-0"> <i class="ri-zoom-in-fill mx-2"></i></p>
                                         <p class="mb-0"> <i class="ri-zoom-out-fill"></i></p>
                                    </div>
                                      
                                     
                                </div>
                            </div> -->
                                <div class="pdf-view2">
                                    <object *ngIf="selectedItem?.check_file" [data]="(apiDomain + selectedItem?.check_file) | safe"
                                        type="application/pdf"
                                        width="100%"></object>
                                </div>

                            </div>
                            <div class="col-md-4">
                                <p class="check-details my-2">POS Uploads Details</p>
                                <ul class="invoice-sync">
                                    <li>
                                        <span>Upload Status : </span>
                                        <span [ngClass]="{
                                            'status-success': selectedItem?.status === 'Completed',
                                            'status-processing': selectedItem?.status === 'Processing',
                                            'status-pending': selectedItem?.status === 'Pending',
                                            'status-error': selectedItem?.status === 'Error'
                                        }">
                                            <i class="ri-circle-fill"></i>
                                        </span>
                                        <strong class="mx-2">{{ selectedItem?.status }}</strong>
                                    </li>
                                    <li *ngIf="selectedItem?.status === 'Error'">
                                        <span>Message : </span>
                                        <strong>{{ selectedItem?.error_response }}</strong>
                                    </li>
                                    <li>
                                        <span>Uploaded Date: </span>
                                        <strong>{{ selectedItem?.creation | date: 'dd/MM/yyyy' }}</strong>
                                    </li>
                                    <li *ngIf="selectedItem?.status =='Completed'">
                                        <span>Check Number :</span>
                                        <strong> {{ selectedItem?.check_number }}</strong>

                                    </li>
                                </ul>
                            </div>

                        </div>


                    </div>
                    <!-- <div class="text-center py-3">
                    <h5>No Data Found</h5>
                </div> -->


                </div>
            </div>
            <div class="text-center py-3" *ngIf="!posuploaddata.length">
                <h5>No Data Found</h5>
            </div>
        </div>
    </div>
    <ng-template let-modal #selectDateToScan>
        <div class="modal-header">
            <h5><strong>{{ date_type | titlecase }} POS Checks </strong></h5>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="poschecks">
                <div class="form-group calendar position-relative mb-3" style="max-width: 100%;">
                    <label for="posChecksDate">Select Checks Date</label>
                    <!-- <input type="month" id="monthYearPicker" class="form-control" [(ngModel)]="posChecksDate" (change)="onMonthYearChange($event)"  > -->
                    <input class="form-control h-auto" [(ngModel)]="posChecksDate" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2"
                        placeholder="Date" [max]="today">
                    <span [owlDateTimeTrigger]="dt2">
                        <i class="ri-calendar-2-line calendericon" style="top: 35px;"></i>
                    </span>
                    <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                   
                    
                </div>
                <small class=" px-3 py-2 date_note my-1"> <b>Note : </b> Please {{ date_type }} the POS bills for the selected date</small>

            </div>
            <div class="d-flex justify-content-end py-2 mt-2">
                <button class="btn btn-sm btn-outline-primary mb-0 pr-2  text-uppercase" type="button"
                    (click)="modal.close()">Cancel</button>
                <button class="btn btn-sm btn-primary mb-0 mx-2 text-uppercase" type="button" *ngIf="date_type == 'scan'"
                    (click)="this.scannerService.acquireImage('scan',null,posChecksDate); modal.close('Success')"
                    [disabled]="!posChecksDate ">Scan Now</button>
                <button class="btn btn-sm btn-primary mb-0 mx-2 text-uppercase" type="button" *ngIf="date_type == 'upload'"
                    (click)="uploadPosChecksFn(uploadPOSChecks); modal.close('Success')" [disabled]="!posChecksDate ">Upload</button>
            </div>
        </div>

    </ng-template>
    <ng-template let-modal #uploadPOSChecks>
        <div class="modal-header">
            <h5><strong>Upload POS Checks</strong></h5>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="">
                <div class="fileUpload" *ngIf="selectedFiles.length==0">
                    <label for="file" class="d-block cursor-pointer text-center">
                        <i class="ri-upload-cloud-line fileUpload-icon"></i>
                        <!-- <h6><strong>Upload Pdf POS Checks</strong></h6> -->
                         <p class="mb-0">
                            <small class=" px-3 py-2 date_note my-1"> <b>Note <i class="ri-information-line"></i> : </b> Please Upload only  .PDF</small>
                         </p>
                    </label>
                    <input accept=".pdf" (change)="selectFiles($event.target.files)" class="opacity-0 d-none" multiple
                        type="file" name="" id="file">
                </div>
                <div *ngIf="selectedFiles.length>0">
                    <div *ngIf="progressInfos.length == 0" class="row">
                        <div class="col-md-2 text-center" *ngFor="let file of selectedFiles; let i = index">
                            <div class="preview-box position-relative">
                                <div class="p-close"><i (click)="removeFromList(file,i)" class="ri-close-circle-line"></i>
                                </div>
                                <div class="p-file"> <i class="ri-file-4-line"></i></div>
                                <div>
                                    <p class="fixed-width ml-2">{{ file?.file?.name }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div *ngIf="progressInfos.length > 0">
                    <div *ngFor="let progressInfo of progressInfos" class="mb-2">
                        <div class="d-flex mx-3">
                            <b *ngIf="progressInfo?.color == 'warning'"> <i class="ri-close-line mr-2" style="color: red;"></i></b>
                            <b *ngIf="progressInfo?.color == 'success'"> <i class="ri-check-line mr-2" style="color: green;"></i></b>
                            <small class="mr-3 col-md-9">{{ progressInfo.fileName }}</small>
                            <span class="col-md-3">
                                <ngb-progressbar [type]="progressInfo.color" textType="white"
                                    [value]="progressInfo.parserProgress + progressInfo.uploadProgress" [showValue]="true">
                                </ngb-progressbar>
                            </span>

                        </div>

                    </div>
                </div>

            </div>
            <div class="modal-footer d-block  pb-4 border-0" *ngIf="selectedFiles.length > 0 ">
                <div class="text-right">

                    <button *ngIf="allFilesUplaoded" class="btn btn-outline-primary mb-0  text-uppercase" type="button"
                        (click)="modal.close('success')">Ok</button>
                    <button *ngIf=" progressInfos.length == 0" class="btn btn-outline-primary mb-0  text-uppercase"
                        type="button" (click)="modal.close()">Cancel</button>

                    <button *ngIf=" progressInfos.length == 0" (click)="uploadFiles()" [disabled]="selectedFiles.length == 0 "
                        class="btn btn-primary mb-0 px-4 ml-3 text-uppercase"
                        type="button">Upload</button>
                </div>
            </div>
            <!-- <div class="d-flex justify-content-end py-2">
              <button class="btn btn-sm btn-outline-primary mb-0 pr-2  text-uppercase" type="button" (click)="modal.close()">Cancel</button>
              <button class="btn btn-sm btn-primary mb-0 mx-2 text-uppercase" type="button" (click)="uploadFiles()" [disabled]="!posChecksDate ">Scan Now</button>
          </div> -->
        </div>

    </ng-template>
    <ng-template #viewcheck let-modal>

        <div class="modal-header border-0 b-r-0 pb-0  my-auto text-left d-block">
            <div class="row no-gutters">
                <div class="col-md-4 my-auto">
                    <div class="px-3">
                        <h6>
                            <strong>Check Preview</strong>
                        </h6>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-body p-2 pdf-view2 bg-white shadow-sm">
            <div class="card">
                <object *ngIf="selectedItem?.check_file" [data]="(apiDomain + selectedItem?.check_file) | safe"
                    type="application/pdf"
                    width="100%" class="h-80"></object>
            </div>
        </div>

        <div class="close-icon">
            <i (click)="modal.dismiss(); getPOSChecksData(); selectedInvoiceNo ={}" class="ri-close-line"></i>
        </div>

    </ng-template>

</section>
